import React, { useState, useContext, useEffect } from "react";
import { format } from "date-fns";

//package import

import {
  Box,
  Typography,
  Grid,
  Avatar,
  Paper,
  useTheme,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

//user import

import Globe from "../../../Svg/Globe";
import Delivery from "../../../Svg/Delivery";
import Wastedvaccine from "../../../Svg/Wastedvaccine";
import Vaccinated from "../../../Svg/Vaccinated";
import { RoutesUrls, districtRoutes } from "../../../Services/Routes/APP";
import Piechart from "../../shared/PieChart";
import Barchart from "../../shared/Barchart";
import { district_Context } from "../../../context";
import { headersPost, headersUpdate } from "../../../Services/API";
import { DISTRICTS_API_ULRS } from "../../../Services/Routes/API";
import DetailsIcon from "../../../Svg/DetailIcon";
import BellIcon from "../../../Svg/BellIcon";
import AlertBallIcon from "../../../Svg/AlertBallIcon";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

// styles
const useStyles = makeStyles({
  hiddenScrollBar: {
    padding: "1rem",
    overflowY: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  notificationDropdownBox: {
    "& .MuiPaper-root": {
      height: "fit-content",
      maxHeight: "50%",
      padding: "5%, 15%",
      borderRadius: 5,

      width: "27%",
      "@media (max-width: 960px)": {
        width: "35%",
      },
      "@media (max-width: 780px)": {
        width: "40%",
      },
      "@media (max-width: 660px)": {
        width: "50%",
      },
      "@media (max-width: 480px)": {
        width: "60%",
      },

      overflowY: "scroll",
      "-ms-overflow-style": "none",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  notificationListItem: {
    whiteSpace: "break-spaces",
    margin: "0.5em",
    padding: 0,
  },
  notificationText: {
    fontSize: "0.8rem",
    lineHeight: 1,
  },
});

//constants

const headings = ["Sender", "Date", "Units Requested", "Actions"];

//component

const Dashboard = ({
  cableConnectionDisconnected,
  retryCableConnection,
  newNotification,
  clearNewNotification,
}) => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  //states
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  const [barChartData, setBarChartData] = useState(null);
  const [pieChartData, setPieChartData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [tableData, setTableData] = useState([]);
  const [childNodes, setChildNodes] = useState("");
  const [vaccinesUsedCount, setVaccinesUsedCount] = useState("");
  const [wastedCount, setWastedCount] = useState("");
  const [totalTransferedCount, setTotalTransferedCount] = useState("");
  const [notificationsList, setNotificationsList] = useState([]);
  const [notificationSeen, setNotificationSeen] = useState(true);
  const [searchData, setSearchData] = useState("");
  const [notificationIdsListToUpdateSeen, setNotificationIdsListToUpdateSeen] =
    useState([]);
  const [
    triggeredToUpdateNotificationSeen,
    setTriggeredToUpdateNotificationSeen,
  ] = useState(false);

  const handleDropdownTriggerClick = (event) => {
    const newDropdownEl = event.currentTarget;
    if (newDropdownEl?.id === "notification-dropdown-trigger") {
      updateNotificationsSeenStatus();
    }
    setDropdownAnchorEl(newDropdownEl);
  };

  const updateNotificationsSeenStatus = () => {
    const data = {
      notification_ids: notificationsList
        ?.filter((notifi) => !notifi?.seen)
        .map((notif) => notif?.id),
    };
    if (data.notification_ids?.length > 0) {
      headersUpdate(DISTRICTS_API_ULRS.UPDATE_NOTIFICATION_STATUS, data).then(
        (res) => {
          if (res?.status === 200 && res?.data?.success) {
            const toUpdateNotificationIdsList =
              res?.data?.notification_ids_to_update;
            if (toUpdateNotificationIdsList?.length > 0) {
              setNotificationIdsListToUpdateSeen(toUpdateNotificationIdsList);
            } else {
              setTriggeredToUpdateNotificationSeen(false);
            }
          }
        }
      );
    } else {
      setTriggeredToUpdateNotificationSeen(false);
    }
  };

  const handleDropdownClose = () => {
    setDropdownAnchorEl(null);
  };

  //addHandler Function

  const addHandler = () => {
    navigate(RoutesUrls.districtAdmin + districtRoutes.requests, {
      state: { type: "received" },
    });
  };

  const addHandler2 = () => {
    navigate(RoutesUrls.districtAdmin + districtRoutes.dashboardDetails);
  };

  // logout handler

  const logoutHandler = () => {
    localStorage.clear();
    navigate(RoutesUrls?.root);
  };

  // dashboard data

  const getDashboardData = () => {
    const data = {
      dashboard_request: {
        view_level: "district",
      },
    };

    headersPost(DISTRICTS_API_ULRS.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setBarChartData(res.data?.barChartData);
          setPieChartData(res.data?.pieChartData);
          setTableData(res.data?.received_requests);
          setChildNodes(res.data?.total_child_nodes);
          setTotalTransferedCount(res.data?.total_transferred);
          setVaccinesUsedCount(res.data?.vaccinated_count);
          setWastedCount(res.data?.wasted_count);
          setNotificationsList(res.data?.notifications?.list);
          if (res.data?.notifications?.unseen_count > 0) {
            setNotificationSeen(false);
          }
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // life cycle

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    if (newNotification) {
      setNotificationsList((prevList) => [newNotification, ...prevList]);
      clearNewNotification(newNotification);
    }
  }, [newNotification]);

  useEffect(() => {
    if (
      notificationsList?.filter((notif) => notif?.seen === false)?.length > 0
    ) {
      setNotificationSeen(false);
    } else if (!notificationSeen) {
      setNotificationSeen(true);
    }
  }, [notificationsList]);

  useEffect(() => {
    if (
      notificationIdsListToUpdateSeen?.length > 0 &&
      triggeredToUpdateNotificationSeen
    ) {
      if (notificationsList?.length > 0) {
        let newList = [...notificationsList];
        newList = newList?.reduce((resultingArray, not) => {
          let obj = not;
          if (notificationIdsListToUpdateSeen?.includes(not.id)) {
            obj.seen = true;
          }
          return (resultingArray = [...resultingArray, obj]);
        }, []);
        setNotificationsList(newList);
        setNotificationIdsListToUpdateSeen([]);
        setTriggeredToUpdateNotificationSeen(false);
      }
    }
  }, [notificationIdsListToUpdateSeen, triggeredToUpdateNotificationSeen]);

  useEffect(() => {
    if (cableConnectionDisconnected === true) {
      setAlertOpen(true);
      setAlertMsg("Live notifications needs a page reload to work properly!");
      setAlertIcon("error");
      retryCableConnection();
    }
  }, [cableConnectionDisconnected]);

  const classes = useStyles();

  //render

  return (
    <>
      <Grid container spacing={1} mt={4} alignItems={"stretch"}>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            <Box display={"flex"}>
              <Box>
                <Globe width={"70px"} height={"70px"}></Globe>
              </Box>
              <Box
                height={"90px"}
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {childNodes}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Total Clinics of operation.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3} alignItems={"stretch"}>
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Delivery width={"70px"} height={"70px"} />
              </Box>
              <Box
                height={"90px"}
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {totalTransferedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccines delivered to Clinics
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3} alignItems={"stretch"}>
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Vaccinated width={"70px"} height={"70px"} />
              </Box>
              <Box
                height={"90px"}
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {vaccinesUsedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccine Used world wide.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3} alignItems={"stretch"}>
          <Paper
            elevation={1}
            sx={{ borderRadius: 1, padding: theme.spacing(2) }}
          >
            {" "}
            <Box display={"flex"}>
              <Box>
                <Wastedvaccine width={"70px"} height={"70px"} />
              </Box>
              <Box
                height={"90px"}
                sx={{
                  margin: { xs: "7px", sm: "7px" },
                  lineHeight: { xs: "1.235", sm: "1.235" },
                  fontSize: { xs: "1.5625rem", sm: "1.5625rem" },
                  fontWeight: { xs: 700, sm: 700 },
                  fontFamily: {
                    xs: "Inter,sans-serif",
                    sm: "Inter,sans-serif",
                  },
                  marginLeft: { xs: 2, sm: 2, md: 4, lg: 4 },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: { sm: 1, xs: 1, md: 1, lg: 1 },
                  }}
                >
                  {wastedCount}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    lineHeight: { sm: 1, xs: 1, md: 1, lg: 1 },
                    color: "text.secondary",
                  }}
                >
                  Vaccine wasted world wide.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Paper elevation={1}>
        <Box pl={3} pt={3} pb={0} mt={4}>
          <Typography variant="h5">Requests Recieved</Typography>
          <Typography variant="p" color={"text.grayText"}>
            Most Recent
          </Typography>
        </Box>
        <TableContainer component={Paper}>
          {/* sx={{ minWidth: 650 }} */}
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor:
                          index === headings.length - 1
                            ? `${theme.palette.error.light}`
                            : `${theme.palette.secondary.dark}`,
                        borderRadius: 2,
                        color:
                          index === headings.length - 1
                            ? `${theme.palette.error.main}`
                            : `${theme.palette.primary.main}`,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.length > 0 ? (
                tableData?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell align="center">{row?.sender_name}</TableCell>

                    <TableCell align="center">
                      {" "}
                      {row?.created_at
                        ? format(new Date(row?.created_at), "MM/dd/yyyy")
                        : ""}
                    </TableCell>
                    <TableCell align="center">{row?.quantity}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Details">
                        <Button
                          color="secondary"
                          variant="contained"
                          onClick={() => addHandler(row)}
                          sx={{
                            borderRadius: 1,

                            minWidth: 2,
                            paddingX: 1,
                          }}
                        >
                          <DetailsIcon />
                        </Button>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  {" "}
                  <TableCell colSpan={4}>
                    {" "}
                    <Typography
                      variant="body1"
                      width={"100%"}
                      sx={{
                        textAlign: "center",
                      }}
                    >
                      No Data Found
                    </Typography>{" "}
                  </TableCell>{" "}
                </TableRow>
              )}
            </TableBody>
          </Table>

          <Box display={"flex"} justifyContent={"center"}>
            <Button onClick={addHandler} disabled={!(tableData?.length > 0)}>
              {tableData?.length ? "See More" : ""}
            </Button>
          </Box>
        </TableContainer>
      </Paper>
      <Grid container mt={2} spacing={2}>
        {pieChartData && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <Paper elevation={1} sx={{ paddingBottom: 1 }}>
              <Typography variant="h5" padding={2} paddingX={2}>
                General Overview
              </Typography>
              <Typography
                variant="subtitle2"
                color={"text.grayText"}
                paddingX={2}
              >
                Overall Population Served
              </Typography>
              <Box
                width={"100%"}
                height={200}
                display={"flex"}
                justifyContent={"center"}
                color={"text.grayText"}
                pt={2}
              >
                {pieChartData?.[0]?.value === 0 ||
                  pieChartData?.[1]?.value === 0 ? (
                  <Typography
                    variant="body1"
                    color={"text.grayText"}
                    padding={2}
                    mt={7}
                  >
                    No Record Found
                  </Typography>
                ) : (
                  <Piechart data={pieChartData} />
                )}
              </Box>
              <Grid container mt={2} display={"flex"} justifyContent={"center"}>
                <Grid container paddingX={2}>
                  <Box
                    width={30}
                    borderRadius={2}
                    height={30}
                    bgcolor="#5E3FBE"
                  ></Box>
                  <Typography color={"text.grayText"} pl={2}>
                    Population Vaccinated
                  </Typography>
                </Grid>
                <Grid container padding={2}>
                  <Box
                    width={30}
                    borderRadius={2}
                    height={30}
                    bgcolor={theme.palette.grey.A100}
                  ></Box>
                  <Typography color={"text.grayText"} pl={2}>
                    Non - vaccinated
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        {barChartData && (
          <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
            <Paper elevation={1}>
              <Typography variant="h5" pt={2} paddingX={2}>
                Monthly Overview
              </Typography>
              <Typography
                variant="subtitle2"
                color={"text.grayText"}
                paddingX={2}
              >
                Population Served per month
              </Typography>
              <Box
                width={"100%"}
                height={315}
                display={"flex"}
                justifyContent={"center"}
                pt={4}
              >
                <Barchart data={barChartData} />
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Dashboard;
